<template>

    <div class="modal-mask" id="chat">
        <div class="modal-wrapper">
            <div class="modal-container d-flex flex-column">
                <header class="mdc-top-app-bar position-static">
                    <div class="mdc-top-app-bar__row">
                        <section class="mdc-top-app-bar__section mdc-top-app-bar__section--align-start">
                            <a class="material-icons mdc-top-app-bar__navigation-icon" @click="$router.go(-1)">close</a>
                        </section>
                        <section class="mdc-top-app-bar__section title">
                            <div class="mdc-top-app-bar__title">
                                {{$t('1202')}}
                                <!-- 1:1 문의 -->
                            </div>                
                        </section>
                        <section class="mdc-top-app-bar__section mdc-top-app-bar__section--align-end">
                            <a class="material-icons mdc-top-app-bar__action-item" aria-label="search" alt="search"></a>
                        </section>
                    </div>
                </header>
                <section class="flex-grow-1 scroll-y">
                    <section id="chatContainer">
                        <ul>
                            <li v-for="(chat, index) in chatData" :key="index">
                                
                                <div class="datetime"
                                    v-if="index === 0 || (index > 0 && $moment(chat.created).diff($moment(chatData[index-1].created),'days') > 0)" 
                                >
                                    <span class="t-helper">

                                        {{$moment(chat.created).format('LL')}}
                                    </span>
                                </div>
                                <div class="chat-body"
                                    :class="{
                                        'me': !chat.owner,
                                        'other': chat.owner,
                                        'with-avatar': index === 0 && chat.owner,
                                        'with-avatar': index > 0 && chatData[index-1].owner !== chat.owner && chat.owner,
                                        'first': index > 0 && chatData[index-1].owner !== chat.owner,
                                    }"
                                >
                                    <div class="picture" v-if="chat.owner">
                                        <img class="avatar" src="../../assets/woman-head.png" alt="" v-if="index === 0 && chat.owner || (index > 0 && chatData[index-1].owner !== chat.owner && chat.owner)"/>
                                        <!-- <img class="avatar" :src="chat.writerProfile" alt="Avatar"/> -->
                                    </div>
                                    
                                    <div class="text">
                                        <span class="t-body3">
                                            {{chat.contents ? chat.contents : 'No Message'}}
                                        </span>
                                        <!-- <div v-if="index > 0">
                                            {{$moment(chat.created).format('L')}}
                                            <br>{{$moment(chatData[index-1].created).format('L')}}
                                            <br>{{$moment(chat.created).diff($moment(chatData[index-1].created),'days')}}
                                        </div> -->
                                    </div>
                                    <span class="t-helper">
                                        {{$moment(chat.created).format('LT')}}
                                        <!-- {{$moment(chat.created).format('L')}} -->
                                    </span>
                                </div>
                            </li>
                        </ul>
                    </section>
                </section>
                <section>
                    <form @submit.prevent="sendChat()" novalidate>
                    <section id="messageContainer">
                        <input type="text" :placeholder="$t('1203')" v-model="contents"/>
                        <!-- 내용을 입력하세요. -->
                        <button class="mdc-icon-button" id="btnSend" @click="sendChat()" :class="{'on': isContents}" :disabled="!isContents"></button>
                        <div class="clearfix"></div>                                
                    </section>
                    </form>
                </section>
                
                
            </div>
        </div>
    </div>

</template>

<script>
/**
 * 멤버십 - 구매 상세 질문하기 컴포넌트(membership - purchase question component)
 *
 * @author minkyoung.park@emcast.com
 */

// Components/Mixin/Extend/API define
import salesApi from '@/api/salesApi.js'

export default {
    data() {
        return {
            orderId: this.$route.params.orderId,
            contents: '',
            chatData: []
        }
    },

    mounted() {
        let params = {
            orderId: this.orderId
        }

        // get qna list
        salesApi.salesQnAList(params).then((response) => {
            this.chatData = response.data.data
        }).catch((err) => {

        })
    },

    updated() {
        this.moveScrollBottom()
    },

    computed: {
        isContents() {        
            return !!this.contents
        }

    },

    methods: {
        
        // regist question
        sendChat() {
            let params = {
                orderId: this.orderId,
                contents: this.contents
            }

            salesApi.salesQnAWrite(params).then((response) => {
                this.chatData.push(response.data.data)
            }).catch((err) => {

            })
            
            this.contents = ''
        },

        moveScrollBottom() {
            let container = this.$el.querySelector("#chatContainer")
            container.scrollTop = container.scrollHeight

        }
    }
}
</script>